import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { endTestTimer } from "../redux/test/actions";

const ExamTimer = ({ totalTime }) => {
  const [timeLeft, setTimeLeft] = useState(totalTime);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime === 0) {
          clearInterval(timer);
          dispatch(endTestTimer());
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [totalTime]);

  const hours = Math.floor(timeLeft / 3600); // Calculate hours
  const minutes = Math.floor((timeLeft % 3600) / 60); // Calculate minutes
  const seconds = timeLeft % 60; // Calculate seconds

  return (
    <span className=" text-white text-xl font-semibold">
      {hours.toString().padStart(2, "0")}:{minutes.toString().padStart(2, "0")}:
      {seconds.toString().padStart(2, "0")}
    </span>
  );
};

export default ExamTimer;
